var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAmatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1332_34441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58512 8.53406L5.65137 10.2792H7.86105L6.58512 8.53406Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07227 11.6855L10.4143 16.44L8.74789 11.6855H6.07227Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.615 7.91956H7.87793L9.24621 9.79081L10.615 7.91956Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 8.40747L10.6318 10.2792H13.3689L12.0001 8.40747Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2378 11.6855L11.9998 16.7128L13.7623 11.6855H10.2378Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1223 7.91956H13.3853L14.754 9.79081L16.1223 7.91956Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5859 16.44L17.928 11.6855H15.2523L13.5859 16.44Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1392 10.2792H18.3484L17.4151 8.53406L16.1392 10.2792Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4853 3.51469C18.2189 1.24828 15.2053 0 12 0C8.79469 0 5.78109 1.24828 3.51469 3.51469C1.24828 5.78109 0 8.79469 0 12C0 15.2053 1.24828 18.2189 3.51469 20.4853C5.78109 22.7517 8.79469 24 12 24C15.2053 24 18.2189 22.7517 20.4853 20.4853C22.7517 18.2189 24 15.2053 24 12C24 8.79469 22.7517 5.78109 20.4853 3.51469ZM19.6725 11.8603L13.0894 19.0687C12.8105 19.3739 12.4134 19.5492 12 19.5492C11.5866 19.5492 11.1895 19.3739 10.9106 19.0687L4.3275 11.8603C3.90656 11.3991 3.82125 10.7189 4.11609 10.1681L5.65406 7.29328C5.91141 6.81234 6.40969 6.51328 6.95531 6.51328H17.0447C17.5903 6.51328 18.0886 6.81234 18.3459 7.29328L19.8839 10.1681C20.0011 10.387 20.0583 10.6261 20.0583 10.8637C20.0583 11.2247 19.9261 11.5823 19.6725 11.8603Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1332_34441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAmatic);
export default __webpack_public_path__ + "static/media/icon-amatic.ec1010de3971e2d4e852c01b975cb781.svg";
export { ForwardRef as ReactComponent };